const ERROR_TITLES = {
  OrderCheckoutWindowRule: "Ordering Window Closed",
  ModificationCheckinWindowRule: "Ordering Window Closed",
  quote_number: "There's a Problem With Your Reservation",
  vrms_coid: "Invalid Customer",
  customer: "Invalid Customer",
  checkin_date: "Invalid Travel Dates",
  checkout_date: "Invalid Travel Dates",
  ReservationDisabledRule: "Invalid Reservation",
  ReservationCancelledRule: "Reservation Cancelled",
  PropertyServiceableRule: "Invalid Property",
  OwnerPromotionWindowRule: "Invalid Owner Reservation",
  ReservationConfirmedRule: "Unconfirmed Reservation",
  ContractDatesRule: "Invalid Travel Dates",
  CreditAvailableRule: "Invalid Reservation",
  NotFound: "Oops! Something went wrong.",
};

const GENERIC_ERROR =
  "There's been an error. Please try again, or contact customer support.";

const SUCCESS = 200 | 201;

const BAD_REQUEST = 400;
const NOT_FOUND = 404;
const UNPROCESSIBLE_ENTITY = 422;

const INTERNAL_SERVER_ERROR = 500;

let UNKNOWN_CLIENT_ERROR = 0;
let UNKNOWN_SERVER_ERROR = 0;

for (let code = BAD_REQUEST + 1; code < INTERNAL_SERVER_ERROR; code++) {
  if (
    ![
      BAD_REQUEST,
      NOT_FOUND,
      UNPROCESSIBLE_ENTITY,
      INTERNAL_SERVER_ERROR,
    ].includes(code)
  ) {
    if (code >= INTERNAL_SERVER_ERROR) {
      UNKNOWN_CLIENT_ERROR |= 1 << code;
    } else {
      UNKNOWN_SERVER_ERROR |= 1 << code;
    }
  }
}

export {
  BAD_REQUEST,
  ERROR_TITLES,
  GENERIC_ERROR,
  INTERNAL_SERVER_ERROR,
  NOT_FOUND,
  SUCCESS,
  UNKNOWN_CLIENT_ERROR,
  UNKNOWN_SERVER_ERROR,
  UNPROCESSIBLE_ENTITY
};

